<template>
  <div>
    <div>
      <div class="alnCt ant-descriptions-title">
        <span style="color: #1890FF">▋</span>基本信息
      </div>
      <div class="alnCt mt20 descCont">
        <div class="avaCont">
          <a-avatar shape="square" :size="180" :src="info.headImageUrl"/>
        </div>
        <div class="flx1">
          <a-descriptions bordered size="small">
            <a-descriptions-item label="姓名">{{info.name}}</a-descriptions-item>
            <a-descriptions-item label="身高(cm)">{{info.height}}</a-descriptions-item>
            <a-descriptions-item label="家庭地址">{{info.address}}</a-descriptions-item>
            <a-descriptions-item label="籍贯">{{info.nativePlace}}</a-descriptions-item>
            <!-- <a-descriptions-item label="家庭地址">{{$getCityById(info.address)}}</a-descriptions-item> -->
            <!-- <a-descriptions-item label="籍贯">{{$getCityById(info.nativePlace)}}</a-descriptions-item> -->
            <a-descriptions-item label="体重(kg)">{{info.weight}}</a-descriptions-item>
            <a-descriptions-item label="详细地址">{{info.detailedAddress}}</a-descriptions-item>
            <a-descriptions-item label="性别">{{info.sex == 1 ? '男' : '女'}}</a-descriptions-item>
            <a-descriptions-item label="手机号码">{{info.phone}}</a-descriptions-item>
            <a-descriptions-item label="所在机构">{{info.employerName}}</a-descriptions-item>
            <a-descriptions-item label="生日">{{info.birthday}}</a-descriptions-item>
            <a-descriptions-item label="身份证号码">{{info.idCardNo}}</a-descriptions-item>
            <a-descriptions-item label="入队时间">{{info.workingTime}}</a-descriptions-item>
            <a-descriptions-item label="年龄">{{info.age}}</a-descriptions-item>
            <a-descriptions-item label="邮箱">{{info.email}}</a-descriptions-item>
            <a-descriptions-item label="训练项目">{{info.trainingProject}}</a-descriptions-item>
            <!-- <a-descriptions-item label="职位">{{info.positionName}}</a-descriptions-item> -->
            <a-descriptions-item label="所属组别">{{info.groupName}}</a-descriptions-item>
          </a-descriptions>
        </div>
      </div>
    </div>
    <div class="mt20">
      <div class="alnCt ant-descriptions-title">
        <span style="color: #1890FF">▋</span>个人成绩
      </div>
      <a-descriptions bordered size="small" layout="vertical">
        <a-descriptions-item label="运动员等级" >{{(info.achieves && info.achieves.length > 0) ? info.achieves[0].sportsLevelName : ''}}</a-descriptions-item>
        <a-descriptions-item label="运动成绩" >{{(info.achieves && info.achieves.length > 0) ? info.achieves[0].sportPerformance : ''}}</a-descriptions-item>
      </a-descriptions>
    </div>
    <div class="mt20">
      <div class="alnCt ant-descriptions-title">
        <span style="color: #1890FF">▋</span>其他信息
      </div>
      <a-descriptions bordered size="small" layout="vertical">
        <a-descriptions-item label="备注" >{{info.remark}}</a-descriptions-item>
      </a-descriptions>
    </div>
    <div class="mt20">
      <div class="alnCt ant-descriptions-title">
        <span style="color: #1890FF">▋</span>操作记录
      </div>
      <div class="wz-pl-2">
        <a-empty v-if="operatingList.length <= 0" :image="simpleImage" />
        <div class="mt10" v-for="(item, index) in operatingList" :key="index">
          <a-badge color="#108ee9" :text="item.dayTxt" />
          <div class="mt10">
            <a-card>
              <div class="spcBt">
                <div>
                  <a-avatar size="large" :src="item.headImageUrl">
                    <template #icon>
                      <UserOutlined />
                    </template>
                  </a-avatar>
                  <span class="ml10">{{item.name}}</span>
                </div>
                <div>{{item.timeTxt}}</div>
              </div>
              <div class="mt10">操作：{{item.operatingType}}</div>
            </a-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Empty } from "ant-design-vue";

export default {
  inject: ['getInfo', 'getOperatingList'],
  data() {
    return {
      simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,
    };
  },
  computed: {
    info() {
      return this.getInfo();
    },
    operatingList() {
      return this.getOperatingList();
    }
  },
  mounted() {},
  methods: {},
};
</script>
<style scoped lang="less">
@import "/src/styles/common/common.less";
:deep(.ant-descriptions-title){
  margin-top: 20px !important;
}
.descCont {
  position: relative;
  padding-left: 330px;
}
.avaCont {
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 330px;
  height: 100%;
  border:0;
  // border-top: 1px solid #e8e8e8;
  // border-left: 1px solid #e8e8e8;
  // border-bottom: 1px solid #e8e8e8;
  background-color: #21284B;
}
</style>